module.exports = __webpack_public_path__ + "img/icon-history.08420a38.svg";